module.exports = {"TXTWCL_Leave_Club":{"id":"TXTWCL_Leave_Club","defaultMessage":"Покинути клуб","track":"Leave Club"}}